import { QueryParamsModel } from '../../_base/crud';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Immunization } from '../_models/immunization.model';
import { ImmunizationActions, ImmunizationActionTypes } from '../_actions/immunization.actions';

export interface ImmunizationsState extends EntityState<Immunization> {
  entityId: number;
  loading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedContactRelationshipId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export function selectImmunizationId(immunization: Immunization): number {
  return immunization.id;
}
export const adapter: EntityAdapter<Immunization> = createEntityAdapter<Immunization>({
  selectId: selectImmunizationId,
});

export const initialImmunizationsState: ImmunizationsState = adapter.getInitialState({
  loading: false,
  actionsloading: false,
  totalCount: 0,
  entityId: undefined,
  lastCreatedContactRelationshipId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function ImmunizationsReducer(
  state = initialImmunizationsState,
  action: ImmunizationActions,
): ImmunizationsState {
  switch (action.type) {
    case ImmunizationActionTypes.ThrowImmunizationError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        loading: false,
      };
    }
    case ImmunizationActionTypes.ImmunizationUpdated:
      return adapter.updateOne(action.payload.immunization, state);
    case ImmunizationActionTypes.ImmunizationPageToggleLoading:
      return {
        ...state,
        loading: action.payload.isLoading,
        lastCreatedContactRelationshipId: undefined,
      };
    case ImmunizationActionTypes.ImmunizationPageRequested:
      return {
        ...state,
        totalCount: 0,
        loading: true,
        showInitWaitingMessage: true,
        entityId: action.payload.entityId,
        lastQuery: action.payload.page,
      };
    case ImmunizationActionTypes.ImmunizationPageLoaded:
      return adapter.addMany(action.payload.immunizations, {
        ...initialImmunizationsState,
        totalCount: action.payload.totalCount,
        loading: false,
        entityId: state.entityId,
        lastQuery: state.lastQuery,
        showInitWaitingMessage: false,
      });
    case ImmunizationActionTypes.ImmunizationOnServerCreated:
      return { ...state, loading: true };
    case ImmunizationActionTypes.ClearImmunizationErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case ImmunizationActionTypes.ImmunizationCreated:
      return adapter.addOne(action.payload.immunization, {
        ...state,
        lastCreatedContactRelationshipId: action.payload.immunization.id,
      });
    case ImmunizationActionTypes.ImmunizationActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    default:
      return state;
  }
}
export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
